import { Box, Paper, Stack, Typography } from "@mui/material";

/**
 * White outlined card on the canvas. The default container for any block
 * of related content — tables, forms, key-value lists, etc.
 *
 * Optional header strip with title / subtitle / actions. Pass `disablePadding`
 * for cases like data tables that want zero inset on their content.
 */
export default function SectionCard({
  title,
  subtitle,
  actions,
  footer,
  disablePadding = false,
  children,
  sx,
}) {
  const hasHeader = title || subtitle || actions;

  return (
    <Paper variant="outlined" sx={{ overflow: "hidden", ...sx }}>
      {hasHeader && (
        <Stack
          direction={{ xs: "column", sm: "row" }}
          alignItems={{ xs: "stretch", sm: "center" }}
          justifyContent="space-between"
          spacing={1.5}
          sx={{
            px: { xs: 2, sm: 2.5 },
            py: 1.5,
            borderBottom: 1,
            borderColor: "divider",
          }}
        >
          <Box sx={{ minWidth: 0 }}>
            {title && (
              <Typography variant="subtitle1" fontWeight={700}>
                {title}
              </Typography>
            )}
            {subtitle && (
              <Typography variant="body2" color="text.secondary">
                {subtitle}
              </Typography>
            )}
          </Box>
          {actions && (
            <Stack
              direction="row"
              alignItems="center"
              spacing={1}
              flexWrap="wrap"
              useFlexGap
              sx={{ flexShrink: 0 }}
            >
              {actions}
            </Stack>
          )}
        </Stack>
      )}
      <Box sx={{ p: disablePadding ? 0 : { xs: 2, sm: 2.5 } }}>{children}</Box>
      {footer && (
        <Box
          sx={{
            px: { xs: 2, sm: 2.5 },
            py: 1.5,
            borderTop: 1,
            borderColor: "divider",
          }}
        >
          {footer}
        </Box>
      )}
    </Paper>
  );
}
